export const IS_DESKTOP = process.env.REACT_APP_DESKTOP === "1";
export const DEFAULT_CLOUD_URL = process.env.REACT_APP_CLOUD_URL || "https://mufapos.com";

export const fmtBytes = (n) => (n ? `${(n / 1048576).toFixed(0)} MB` : "-");

export const syncLabel = (s) => {
  if (!s?.linked) return "Belum terhubung cloud";
  if (s.running) return "Menyinkronkan…";
  if (s.status === "ok") return s.pending ? `${s.pending} data menunggu` : "Tersinkron";
  if (s.status === "offline") return "Offline — data aman lokal";
  if (s.status === "revoked") return "Diputus dari cloud";
  return "Perlu perhatian";
};
